import React from 'react'
import { Card,CardContent,Typography } from '@material-ui/core';
import './InfoBox.css';
import numeral from 'numeral'


function InfoBox({title,isRed,cases,total,clicked,active}) {
    return (
        <Card 
        className={`infoBox ${active && 'infoBox--selected'} ${isRed && 'infoBox--red'} `} 
        onClick={clicked}>
            
            <CardContent>
                <Typography className="infoBox__title" color="textSecondary">
                    {title}
                </Typography>
                <h5 className={`infoBox__cases ${!isRed && 'infoBox__cases--green'}`}>+{numeral(cases).format("0,0a")}</h5>
                <Typography color="textSecondary" className="infoBox__total">
                    {numeral(total).format("0,0a")} Total
                </Typography>
            </CardContent>
        </Card>
    )
}

export default InfoBox
